import script from "./EditChargeMasterDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./EditChargeMasterDialog.vue?vue&type=script&setup=true&lang=js"

import "./EditChargeMasterDialog.vue?vue&type=style&index=0&id=26ee5a46&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26ee5a46"]])

export default __exports__
import QItem from 'quasar/src/components/item/QItem.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QItem});
